
import './Policies.css'

export default function Policies() {
    return (<div id="Policies">
<h1>TERMS OF SERVICE</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>These Terms of Service (&quot;<strong>Terms</strong>&quot;) govern your access to and use of <a href="https://questguardrpg.com"><strong>https://questguardrpg.com</strong></a>, including all related websites, applications, downloadable content, digital tools, services, software, databases, APIs, and other features provided by <strong>GRIFFINCRAFT S.R.L.</strong> (collectively, the &quot;<strong>Service</strong>&quot; or &quot;<strong>QuestGuard</strong>&quot;).</p>
<p>By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to these Terms, you must not access or use the Service.</p>
<hr/>
<h1>1. THE PARTIES</h1>
<p>These Terms constitute a legally binding agreement between:</p>
<p><strong>GRIFFINCRAFT S.R.L.</strong> and any individual or legal entity accessing or using the Service (&quot;<strong>User</strong>&quot;, &quot;<strong>you</strong>&quot;, or &quot;<strong>your</strong>&quot;).</p>
<hr/>
<h1>2. DEFINITIONS</h1>
<p>For the purposes of these Terms:</p>
<p><strong>Account</strong> means a QuestGuard account created through Google Authentication.</p>
<p><strong>Service</strong> means the QuestGuard website, software, digital content, downloadable materials, tools, databases, APIs, and any related services provided by GRIFFINCRAFT S.R.L.</p>
<p><strong>Products</strong> means digital products, downloadable files, physical products, premium content, memberships, or any other purchasable offerings made available through the Service.</p>
<p><strong>User Content</strong> means any content created, uploaded, imported, submitted, published, stored, or shared by a User, including but not limited to campaigns, adventures, encounters, monsters, items, maps, notes, characters, JSON files, YAML files, images, Base64 assets, URLs, comments, and any other user-generated material.</p>
<hr/>
<h1>3. ELIGIBILITY</h1>
<p>The Service is intended for a general audience.</p>
<p>If you are under the age at which applicable law permits you to enter into binding agreements independently, you may only use the Service with the consent or supervision of a parent or legal guardian.</p>
<p>By using the Service, you represent that you have the legal capacity to accept these Terms under the laws applicable to you.</p>
<hr/>
<h1>4. ACCOUNT REGISTRATION</h1>
<p>Access to certain features requires a QuestGuard Account.</p>
<p>Accounts are currently created through Google Authentication.</p>
<p>You agree to:</p>
<ul>
<li>provide accurate account information;</li>
<li>maintain the security of your Google account;</li>
<li>promptly notify QuestGuard of unauthorized access to your account where you become aware of it.</li>
</ul>
<p>You are responsible for all activities occurring under your Account unless prohibited by applicable law.</p>
<hr/>
<h1>5. ACCOUNT OWNERSHIP AND TRANSFERS</h1>
<p>Accounts are personal.</p>
<p>Unless expressly authorized by QuestGuard:</p>
<ul>
<li>Accounts may not be sold;</li>
<li>Accounts may not be transferred;</li>
<li>Accounts may not be rented;</li>
<li>Accounts may not be shared for commercial purposes;</li>
<li>Access to purchased Products may not be transferred to another Account.</li>
</ul>
<p>QuestGuard reserves the right to refuse or revoke transfers that violate these Terms.</p>
<hr/>
<h1>6. LICENSE TO USE THE SERVICE</h1>
<p>Subject to these Terms, QuestGuard grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your personal or internal lawful purposes.</p>
<p>Nothing in these Terms transfers ownership of the Service, its software, artwork, rules, trademarks, branding, or other intellectual property.</p>
<p>All rights not expressly granted are reserved.</p>
<hr/>
<h1>7. DIGITAL PRODUCTS</h1>
<p>Purchasing a Product grants you a license to access and use that Product.</p>
<p>Unless otherwise stated:</p>
<ul>
<li>the purchase does not transfer ownership of any intellectual property;</li>
<li>the purchase does not grant resale rights;</li>
<li>the purchase does not permit redistribution;</li>
<li>the purchase does not permit republication;</li>
<li>the purchase does not permit commercial exploitation.</li>
</ul>
<p>Digital Products purchased through QuestGuard may generally be accessed online and downloaded repeatedly while the Service remains commercially available.</p>
<p>QuestGuard does not guarantee that the Service will remain available indefinitely.</p>
<hr/>
<h1>8. SERVICE AVAILABILITY</h1>
<p>QuestGuard is provided on a <strong>commercially reasonable efforts</strong> basis.</p>
<p>GRIFFINCRAFT S.R.L. will use commercially reasonable efforts to maintain the availability, integrity, security, and reliability of the Service.</p>
<p>However, the Service may become unavailable due to reasons including:</p>
<ul>
<li>maintenance;</li>
<li>upgrades;</li>
<li>infrastructure failures;</li>
<li>cloud service interruptions;</li>
<li>cyberattacks;</li>
<li>denial-of-service attacks;</li>
<li>force majeure events;</li>
<li>legal requirements;</li>
<li>business decisions;</li>
<li>discontinuation of the Service.</li>
</ul>
<p>QuestGuard does not guarantee uninterrupted availability or error-free operation.</p>
<h3>8.1 Access Credentials</h3>
<p>QuestGuard may provide access to certain Products, features, or content through activation codes, license keys, promotional codes, Kickstarter reward codes, beta invitations, trial access, or other access credentials (&quot;<strong>Access Credentials</strong>&quot;).</p>
<p>Unless expressly stated otherwise, Access Credentials grant only the rights described at the time they are issued and do not, by themselves, constitute a permanent purchase or ownership interest in any Product.</p>
<p>Certain Access Credentials may be temporary, promotional, campaign-specific, or otherwise subject to expiration or additional conditions. QuestGuard reserves the right to modify, replace, suspend, or revoke such Access Credentials in accordance with their stated terms, including upon expiration, campaign completion, or fulfillment of the purpose for which they were issued.</p>
<p>For example, Access Credentials distributed during crowdfunding campaigns may be intended solely to provide temporary early access to Products or features before campaign fulfillment. Upon fulfillment, QuestGuard may replace such temporary Access Credentials with permanent entitlements corresponding to the rewards earned by the applicable backer.</p>
<p>QuestGuard also reserves the right to suspend or revoke Access Credentials where reasonably necessary, including in cases involving:</p>
<ul>
<li>fraud or attempted fraud;</li>
<li>chargebacks or payment reversals;</li>
<li>unauthorized transfers or resale;</li>
<li>misuse of promotional or campaign codes;</li>
<li>technical or administrative errors resulting in unintended access;</li>
<li>violation of these Terms; or</li>
<li>other circumstances where continued access would be unlawful or would compromise the integrity or security of the Service.</li>
</ul>
<p>Nothing in this Section permits QuestGuard to arbitrarily revoke permanently purchased Products that have been lawfully acquired. Where a User has validly purchased a Product, QuestGuard will honor that purchase in accordance with these Terms, the applicable Refund &amp; Digital Products Policy, and mandatory consumer protection laws. However, QuestGuard does not guarantee perpetual availability of the Service, and continued access to digital Products depends upon the ongoing commercial operation of QuestGuard.</p>
<hr/>
<h1>9. LIVING PLATFORM</h1>
<p>QuestGuard is intended to be a continuously evolving platform.</p>
<p>You acknowledge and agree that QuestGuard may, <strong>in good faith</strong>, at any time:</p>
<ul>
<li>modify rules;</li>
<li>rebalance mechanics;</li>
<li>redesign interfaces;</li>
<li>replace systems;</li>
<li>remove functionality;</li>
<li>introduce new functionality;</li>
<li>reorganize content;</li>
<li>rename features;</li>
<li>update artwork;</li>
<li>revise downloadable materials;</li>
<li>change digital tools;</li>
<li>alter progression systems;</li>
<li>improve existing features;</li>
<li>discontinue obsolete features.</li>
</ul>
<p>Such changes are considered an inherent part of the Service.</p>
<p>Unless expressly stated otherwise, the version of QuestGuard available through the Service constitutes the official and most up-to-date version of the game.</p>
<hr/>
<h1>10. USER CONTENT</h1>
<p>You retain ownership of your User Content.</p>
<p>Nothing in these Terms transfers ownership of your original creative works to QuestGuard.</p>
<p>However, by uploading or creating User Content through the Service, you grant QuestGuard a worldwide, non-exclusive, royalty-free license to:</p>
<ul>
<li>host;</li>
<li>store;</li>
<li>reproduce;</li>
<li>process;</li>
<li>display;</li>
<li>transmit;</li>
<li>synchronize;</li>
<li>cache;</li>
<li>back up;</li>
<li>format;</li>
<li>resize;</li>
<li>generate previews;</li>
<li>technically modify where necessary;</li>
<li>distribute within the Service,</li>
</ul>
<p>solely for the purposes of operating, maintaining, improving, securing, promoting, and providing the Service.</p>
<p>This license continues for as long as reasonably necessary to operate the Service, including maintaining backups.</p>
<hr/>
<h1>11. PUBLIC CONTENT</h1>
<p>If you intentionally publish User Content publicly through the Service, you additionally grant QuestGuard the right to:</p>
<ul>
<li>feature it;</li>
<li>recommend it;</li>
<li>showcase it;</li>
<li>display screenshots;</li>
<li>include it in newsletters;</li>
<li>include it in promotional materials;</li>
<li>display it on social media;</li>
<li>highlight it in articles, videos, livestreams, presentations, or demonstrations relating to QuestGuard.</li>
</ul>
<p>No royalty or additional compensation is owed for such use.</p>
<hr/>
<h1>12. USER RESPONSIBILITIES</h1>
<p>You represent that you possess all rights necessary to upload any User Content.</p>
<p>You are solely responsible for:</p>
<ul>
<li>the legality of your User Content;</li>
<li>obtaining necessary permissions;</li>
<li>ensuring uploaded materials do not infringe third-party rights;</li>
<li>complying with applicable laws.</li>
</ul>
<p>QuestGuard does not pre-screen all User Content.</p>
<hr/>
<h1>13. HOMEBREW CONTENT</h1>
<p>QuestGuard encourages original homebrew creations.</p>
<p>However, User Content may not be used to:</p>
<ul>
<li>reproduce paid QuestGuard Products;</li>
<li>recreate premium content in similar form;</li>
<li>circumvent paid access restrictions;</li>
<li>distribute copyrighted QuestGuard content under the guise of homebrew.</li>
</ul>
<p>QuestGuard reserves the right to remove such content and take appropriate enforcement action.</p>
<hr/>
<h1>14. INTELLECTUAL PROPERTY</h1>
<p>Except for User Content owned by Users, all intellectual property relating to QuestGuard is owned by GRIFFINCRAFT S.R.L. or its licensors.</p>
<p>This includes, without limitation:</p>
<ul>
<li>software;</li>
<li>source code;</li>
<li>databases;</li>
<li>game rules;</li>
<li>official adventures;</li>
<li>official classes;</li>
<li>official races;</li>
<li>official monsters;</li>
<li>artwork;</li>
<li>icons;</li>
<li>layouts;</li>
<li>branding;</li>
<li>logos;</li>
<li>trademarks;</li>
<li>downloadable materials.</li>
</ul>
<p>Unauthorized copying, redistribution, or commercial use is prohibited.</p>
<hr/>
<h1>15. PROHIBITED CONDUCT</h1>
<p>You agree not to:</p>
<ul>
<li>violate applicable laws;</li>
<li>upload malicious software;</li>
<li>interfere with the Service;</li>
<li>gain unauthorized access;</li>
<li>impersonate others;</li>
<li>scrape the Service;</li>
<li>use automated bots to harvest content;</li>
<li>reverse engineer the Service except where mandatory law permits;</li>
<li>bypass access controls;</li>
<li>redistribute paid Products;</li>
<li>upload infringing material;</li>
<li>harass other users;</li>
<li>exploit security vulnerabilities for unauthorized purposes.</li>
</ul>
<hr/>
<h1>16. ARTIFICIAL INTELLIGENCE</h1>
<p>QuestGuard does not use private User Content to train artificial intelligence models without the User&#39;s explicit consent.</p>
<p>Future AI-powered features may be introduced. Where such features require additional processing of User Content beyond the scope of these Terms or the Privacy Policy, QuestGuard will provide appropriate notice or obtain consent where required by applicable law.</p>
<hr/>
<h1>17. BETA FEATURES</h1>
<p>QuestGuard may provide experimental or beta features.</p>
<p>Such features may be incomplete, unstable, modified, or removed without notice.</p>
<p>Beta features are provided &quot;as is&quot; and may not be supported.</p>
<hr/>
<h1>18. SUSPENSION AND TERMINATION</h1>
<p>QuestGuard may, at its sole discretion and where permitted by applicable law, suspend, restrict, terminate, or permanently delete Accounts or User Content with or without prior notice, where it reasonably believes such action is necessary to:</p>
<ul>
<li>enforce these Terms;</li>
<li>protect the Service;</li>
<li>investigate abuse;</li>
<li>prevent fraud;</li>
<li>comply with legal obligations;</li>
<li>protect other Users;</li>
<li>protect QuestGuard&#39;s rights or property.</li>
</ul>
<p>Termination may result in the loss of access to User Content and purchased features where appropriate.</p>
<hr/>
<h1>19. BACKUPS</h1>
<p>QuestGuard may maintain backups for operational purposes.</p>
<p>However, Users remain responsible for maintaining independent backups of important User Content.</p>
<p>QuestGuard does not guarantee recovery of deleted, corrupted, or lost User Content.</p>
<hr/>
<h1>20. THIRD-PARTY SERVICES</h1>
<p>The Service may rely upon third-party providers including, but not limited to:</p>
<ul>
<li>Google;</li>
<li>Firebase;</li>
<li>Stripe;</li>
<li>Cloudflare;</li>
<li>GitHub.</li>
</ul>
<p>QuestGuard is not responsible for the availability or policies of third-party services.</p>
<hr/>
<h1>21. DISCLAIMERS</h1>
<p>Except where prohibited by applicable law, the Service is provided on an &quot;as is&quot; and &quot;as available&quot; basis.</p>
<p>QuestGuard makes no warranty that:</p>
<ul>
<li>the Service will be uninterrupted;</li>
<li>errors will be corrected immediately;</li>
<li>every feature will remain permanently available;</li>
<li>the Service will meet every User&#39;s expectations;</li>
<li>User Content will never be lost.</li>
</ul>
<p>Nothing in these Terms excludes any statutory rights that cannot lawfully be excluded.</p>
<hr/>
<h1>22. LIMITATION OF LIABILITY</h1>
<p>To the fullest extent permitted by applicable law, GRIFFINCRAFT S.R.L., its directors, officers, employees, contractors, and affiliates shall not be liable for any indirect, incidental, consequential, special, exemplary, or punitive damages arising from or relating to the Service, including but not limited to loss of profits, loss of data, business interruption, or loss of goodwill.</p>
<p>Where liability cannot be excluded, the total aggregate liability of GRIFFINCRAFT S.R.L. arising out of or relating to the Service shall not exceed the total amount paid by the affected User to QuestGuard for Products or Services during the twelve (12) months immediately preceding the event giving rise to the claim.</p>
<p>Nothing in these Terms excludes or limits liability for fraud, intentional misconduct, gross negligence where applicable, or any liability that cannot be excluded under applicable law.</p>
<hr/>
<h1>23. INDEMNIFICATION</h1>
<p>You agree to indemnify and hold harmless GRIFFINCRAFT S.R.L. from claims, damages, losses, liabilities, costs, and reasonable legal expenses arising from:</p>
<ul>
<li>your breach of these Terms;</li>
<li>your unlawful conduct;</li>
<li>your User Content;</li>
<li>your infringement of third-party rights.</li>
</ul>
<hr/>
<h1>24. FORCE MAJEURE</h1>
<p>QuestGuard shall not be liable for delays or failures resulting from events beyond its reasonable control, including natural disasters, war, terrorism, labor disputes, governmental actions, internet failures, cloud infrastructure outages, cyberattacks, pandemics, or other force majeure events.</p>
<hr/>
<h1>25. CHANGES TO THE SERVICE AND THESE TERMS</h1>
<p>QuestGuard may update these Terms from time to time.</p>
<p>Material changes may be communicated through the Service or by other reasonable means.</p>
<p>Continued use of the Service after such changes take effect constitutes acceptance of the revised Terms where permitted by applicable law.</p>
<hr/>
<h1>26. GOVERNING LAW</h1>
<p>These Terms shall be governed by and construed in accordance with the laws of Romania, without regard to conflict of law principles.</p>
<p>Nothing in these Terms limits any mandatory consumer rights available under applicable law.</p>
<hr/>
<h1>27. SEVERABILITY</h1>
<p>If any provision of these Terms is found to be unlawful or unenforceable, the remaining provisions shall remain in full force and effect.</p>
<hr/>
<h1>28. WAIVER</h1>
<p>A failure by QuestGuard to enforce any provision of these Terms shall not constitute a waiver of any right or provision.</p>
<hr/>
<h1>29. ASSIGNMENT</h1>
<p>QuestGuard may assign or transfer these Terms, in whole or in part, in connection with a merger, acquisition, sale of assets, corporate restructuring, or operation of the Service.</p>
<p>Users may not assign or transfer their rights or obligations under these Terms without QuestGuard&#39;s prior written consent.</p>
<h1>PRIVACY POLICY</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>This Privacy Policy explains how <strong>GRIFFINCRAFT S.R.L.</strong> (&quot;<strong>GRIFFINCRAFT</strong>&quot;, &quot;<strong>QuestGuard</strong>&quot;, &quot;<strong>we</strong>&quot;, &quot;<strong>our</strong>&quot;, or &quot;<strong>us</strong>&quot;) collects, uses, stores, shares, and protects your personal information when you use <strong><a href="https://questguardrpg.com">https://questguardrpg.com</a></strong> and any related applications, services, downloadable content, or features (collectively, the &quot;<strong>Service</strong>&quot;).</p>
<p>By creating an account, accessing, or using the Service, you acknowledge that you have read and understood this Privacy Policy.</p>
<p>This Privacy Policy has been prepared in accordance with:</p>
<ul>
<li>Regulation (EU) 2016/679 (&quot;GDPR&quot;)</li>
<li>Romanian data protection legislation</li>
<li>Other applicable privacy and consumer protection laws where required</li>
</ul>
<hr/>
<h1>1. DATA CONTROLLER</h1>
<p>The data controller responsible for processing your personal information is:</p>
<p><strong>GRIFFINCRAFT S.R.L.</strong></p>
<p>ID (CUI): 45597040<br/>
EUID: ROONRC.J40/2154/2022<br/>
Romania, București, Sector 3<br/>Strada Alexandru Vlahuță 6<br/>Bloc M46, Scara 1, Apartament 15</p>
<p>Email: <strong><a href="mailto:david.i.irimia@hotmail.com">david.i.irimia@hotmail.com</a></strong>
Website: <a href="https://questguardrpg.com">https://questguardrpg.com</a></p>
<h1>2. DEFINITIONS</h1>
<p>For purposes of this Privacy Policy:</p>
<p><strong>Account</strong> means a QuestGuard account created through Google Authentication.</p>
<p><strong>Personal Data</strong> means any information relating to an identified or identifiable natural person as defined by the GDPR.</p>
<p><strong>User Content</strong> means any content uploaded, created, imported, generated, or shared by a user through the Service, including but not limited to:</p>
<ul>
<li>adventures</li>
<li>campaigns</li>
<li>encounters</li>
<li>character sheets</li>
<li>homebrew content</li>
<li>monsters</li>
<li>maps</li>
<li>notes</li>
<li>JSON files</li>
<li>YAML files</li>
<li>uploaded images</li>
<li>Base64 encoded assets</li>
<li>comments</li>
<li>URLs</li>
<li>custom data structures</li>
<li>any other user-created information.</li>
</ul>
<p><strong>Processing</strong> means any operation performed on Personal Data, including collection, storage, organization, transmission, deletion, or analysis.</p>
<h1>3. INFORMATION WE COLLECT</h1>
<p>Depending on how you use the Service, we may collect the following categories of information.</p>
<h2>3.1 Account Information</h2>
<p>When you sign in using Google Authentication, we receive information made available by your Google account, which may include:</p>
<ul>
<li>full name</li>
<li>email address</li>
<li>Google account identifier</li>
<li>profile picture</li>
<li>authentication tokens necessary to maintain your session</li>
</ul>
<p>We do not receive or store your Google password.</p>
<hr/>
<h2>3.2 Usage Information</h2>
<p>When you use the Service, we may automatically collect information including:</p>
<ul>
<li>IP address</li>
<li>browser type</li>
<li>browser version</li>
<li>operating system</li>
<li>device type</li>
<li>language</li>
<li>screen resolution</li>
<li>approximate geographic region</li>
<li>time zone</li>
<li>pages visited</li>
<li>referring website</li>
<li>session duration</li>
<li>timestamps</li>
<li>feature usage</li>
<li>interaction events</li>
<li>error logs</li>
<li>crash reports</li>
<li>diagnostic information</li>
</ul>
<hr/>
<h2>3.3 User Content</h2>
<p>We collect information that you voluntarily create or upload through the Service, including:</p>
<ul>
<li>campaigns</li>
<li>adventures</li>
<li>encounters</li>
<li>NPCs</li>
<li>creatures</li>
<li>items</li>
<li>maps</li>
<li>character sheets</li>
<li>notes</li>
<li>world-building information</li>
<li>uploaded files</li>
<li>imported JSON</li>
<li>imported YAML</li>
<li>Base64 encoded images</li>
<li>text</li>
<li>configuration files</li>
<li>URLs supplied by users</li>
<li>metadata associated with uploaded content</li>
</ul>
<p>User Content may contain Personal Data depending on what you choose to upload.</p>
<p>You are solely responsible for the Personal Data contained within your User Content.</p>
<hr/>
<h2>3.4 Purchase Information</h2>
<p>If you purchase Products through the Service, we may collect information including:</p>
<ul>
<li>purchased products</li>
<li>order identifiers</li>
<li>transaction identifiers</li>
<li>payment status</li>
<li>purchase history</li>
<li>invoices</li>
<li>applicable taxes</li>
<li>billing country</li>
<li>fulfillment status</li>
</ul>
<p>Payment card information is processed directly by our payment providers and is not stored by QuestGuard.</p>
<hr/>
<h2>3.5 Cookies and Local Storage</h2>
<p>We may store information using:</p>
<ul>
<li>Cookies</li>
<li>Local Storage</li>
<li>Session Storage</li>
<li>IndexedDB</li>
<li>Firebase Authentication persistence</li>
<li>other browser storage technologies</li>
</ul>
<p>More information is available in our Cookie Policy.</p>
<hr/>
<h2>3.6 Communications</h2>
<p>If you contact us, subscribe to newsletters, respond to surveys, or otherwise communicate with us, we may collect:</p>
<ul>
<li>email address</li>
<li>communication history</li>
<li>support requests</li>
<li>feedback</li>
<li>bug reports</li>
<li>feature requests</li>
<li>survey responses</li>
</ul>
<h1>4. HOW WE COLLECT INFORMATION</h1>
<p>We collect information:</p>
<ul>
<li>directly from you</li>
<li>automatically through your use of the Service</li>
<li>through Google Authentication</li>
<li>through Firebase services</li>
<li>through payment processors</li>
<li>through analytics providers</li>
<li>through cookies and similar technologies</li>
<li>from lawful third-party integrations that you authorize</li>
</ul>
<hr/>
<h1>5. PURPOSES OF PROCESSING</h1>
<p>We process Personal Data for purposes including:</p>
<ul>
<li>providing the Service</li>
<li>authenticating users</li>
<li>maintaining accounts</li>
<li>delivering purchased Products</li>
<li>storing User Content</li>
<li>synchronizing data across devices</li>
<li>processing payments</li>
<li>responding to customer support requests</li>
<li>sending newsletters where permitted</li>
<li>sending transactional communications</li>
<li>improving performance</li>
<li>improving security</li>
<li>preventing fraud</li>
<li>detecting abuse</li>
<li>monitoring platform health</li>
<li>generating aggregated statistics</li>
<li>complying with legal obligations</li>
<li>enforcing our Terms of Service</li>
<li>protecting our legal rights</li>
</ul>
<hr/>
<h1>6. LEGAL BASES FOR PROCESSING</h1>
<p>Where GDPR applies, we process Personal Data on one or more of the following legal bases:</p>
<h3>Performance of a Contract</h3>
<p>Including:</p>
<ul>
<li>account management</li>
<li>providing purchased content</li>
<li>synchronizing User Content</li>
<li>delivering requested services</li>
</ul>
<hr/>
<h3>Legitimate Interests</h3>
<p>Including:</p>
<ul>
<li>improving the Service</li>
<li>securing the platform</li>
<li>preventing abuse</li>
<li>detecting fraud</li>
<li>analytics</li>
<li>debugging</li>
<li>maintaining backups</li>
<li>protecting intellectual property</li>
<li>enforcing legal claims</li>
</ul>
<hr/>
<h3>Consent</h3>
<p>Where required, including:</p>
<ul>
<li>newsletters</li>
<li>marketing communications</li>
<li>optional cookies</li>
</ul>
<p>You may withdraw consent at any time.</p>
<hr/>
<h3>Legal Obligation</h3>
<p>Where processing is necessary to comply with applicable laws, regulations, tax obligations, court orders, or lawful requests from public authorities.</p>
<hr/>
<h1>7. GOOGLE AUTHENTICATION</h1>
<p>QuestGuard currently uses Google Sign-In as its authentication provider.</p>
<p>When you choose to sign in with Google, authentication is handled by Google. QuestGuard does not collect, process, or store your Google password.</p>
<p>Google&#39;s processing of your information is governed by Google&#39;s own privacy policies.</p>
<hr/>
<h1>8. USER CONTENT</h1>
<p>QuestGuard allows users to create and upload content.</p>
<p>Such content may include:</p>
<ul>
<li>text</li>
<li>configuration files</li>
<li>campaigns</li>
<li>adventures</li>
<li>JSON</li>
<li>YAML</li>
<li>uploaded images</li>
<li>Base64 images</li>
<li>URLs</li>
<li>other user-created information</li>
</ul>
<p>User Content may contain Personal Data.</p>
<p>We process such information solely for the purpose of operating the Service.</p>
<p>Users remain responsible for ensuring they possess all necessary rights to upload and share User Content.</p>
<p>QuestGuard does not verify ownership of uploaded content.</p>
<hr/>
<h1>9. THIRD-PARTY SERVICES</h1>
<p>We use third-party providers that process Personal Data on our behalf or independently as separate controllers.</p>
<p>These may include:</p>
<ul>
<li>Firebase</li>
<li>Google Authentication</li>
<li>Google Analytics</li>
<li>Stripe</li>
<li>Cloudflare</li>
<li>GitHub</li>
<li>Google Fonts</li>
</ul>
<p>Additional providers may be introduced as the Service evolves.</p>
<p>Each provider maintains its own privacy practices.</p>
<p>We encourage users to review the privacy policies of these providers.</p>
<hr/>
<h1>10. INTERNATIONAL DATA TRANSFERS</h1>
<p>Some third-party providers may process Personal Data outside the European Economic Area.</p>
<p>Where applicable, we rely upon lawful transfer mechanisms recognized under GDPR, including:</p>
<ul>
<li>adequacy decisions</li>
<li>Standard Contractual Clauses</li>
<li>other legally recognized safeguards</li>
</ul>
<hr/>
<h1>11. DATA RETENTION</h1>
<p>We retain Personal Data only for as long as necessary to:</p>
<ul>
<li>provide the Service</li>
<li>fulfill contractual obligations</li>
<li>comply with legal obligations</li>
<li>resolve disputes</li>
<li>enforce agreements</li>
<li>maintain security</li>
<li>establish legal claims</li>
</ul>
<p>Certain information may remain in backups for a reasonable period before permanent deletion.</p>
<p>Where legally required, financial records may be retained for longer periods.</p>
<hr/>
<h1>12. SECURITY</h1>
<p>We implement commercially reasonable administrative, organizational, and technical safeguards designed to protect Personal Data.</p>
<p>These measures may include:</p>
<ul>
<li>encrypted communications</li>
<li>authentication controls</li>
<li>access restrictions</li>
<li>monitoring</li>
<li>backups</li>
<li>secure cloud infrastructure</li>
</ul>
<p>However, no method of electronic transmission or storage is completely secure.</p>
<p>Accordingly, we cannot guarantee absolute security.</p>
<hr/>
<h1>13. YOUR RIGHTS</h1>
<p>Depending on your jurisdiction, you may have the right to:</p>
<ul>
<li>access your Personal Data</li>
<li>correct inaccurate information</li>
<li>delete Personal Data</li>
<li>restrict processing</li>
<li>object to processing</li>
<li>withdraw consent</li>
<li>receive your data in a portable format</li>
<li>lodge a complaint with a supervisory authority</li>
</ul>
<p>Requests may be submitted to:</p>
<p><strong><a href="mailto:david.i.irimia@hotmail.com">david.i.irimia@hotmail.com</a></strong></p>
<p>We may request verification of identity before fulfilling requests.</p>
<hr/>
<h1>14. CHILDREN</h1>
<p>The Service is not directed toward children under the age required by applicable law to provide valid consent for online services.</p>
<p>We do not knowingly collect Personal Data from children without appropriate legal authorization.</p>
<p>If we become aware that such information has been collected unlawfully, we will take reasonable steps to delete it.</p>
<hr/>
<h1>15. AUTOMATED DECISION-MAKING</h1>
<p>QuestGuard does not make decisions producing legal or similarly significant effects solely through automated processing.</p>
<p>Certain automated systems may be used for fraud prevention, security monitoring, spam detection, or analytics.</p>
<hr/>
<h1>16. DO WE SELL PERSONAL DATA?</h1>
<p>No.</p>
<p>QuestGuard does not sell Personal Data to third parties.</p>
<p>We also do not use Personal Data to build advertising profiles for sale to advertisers.</p>
<hr/>
<h1>17. DISCLOSURE OF INFORMATION</h1>
<p>We may disclose Personal Data where necessary:</p>
<ul>
<li>to service providers</li>
<li>to payment processors</li>
<li>to hosting providers</li>
<li>to analytics providers</li>
<li>to law enforcement where legally required</li>
<li>during mergers, acquisitions, or corporate restructuring</li>
<li>to protect our legal rights</li>
<li>to enforce our agreements</li>
<li>to investigate fraud or abuse</li>
</ul>
<hr/>
<h1>18. CHANGES TO THIS PRIVACY POLICY</h1>
<p>We may update this Privacy Policy from time to time. The updates are in good faith and value the protection of the customers.</p>
<p>Material changes may be communicated through the Service or by other reasonable means.</p>
<p>Continued use of the Service following an updated Privacy Policy constitutes acknowledgment of the revised version where permitted by applicable law.</p>
<h1>19. CONTACT</h1>
<p>Questions regarding this Privacy Policy may be directed to GRIFFINCRAFT S.R.L.
All contact details can be found in this document at point <strong>1. DATA CONTROLLER</strong>.</p>
<h1>COOKIE POLICY</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>This Cookie Policy explains how QuestGuard uses cookies and similar technologies when you access or use the Service.</p>
<p>This Policy should be read together with the Terms of Service and Privacy Policy.</p>
<hr/>
<h1>1. WHAT ARE COOKIES?</h1>
<p>Cookies are small text files placed on your device by websites and online services. They allow websites to recognize your browser, remember preferences, maintain authenticated sessions, improve performance, and collect information about how the Service is used.</p>
<p>QuestGuard also uses technologies that perform similar functions without technically being cookies, including Local Storage, IndexedDB, Session Storage, and other browser storage mechanisms. For the purposes of this Policy, references to &quot;cookies&quot; include these technologies unless the context requires otherwise.</p>
<hr/>
<h1>2. WHY QUESTGUARD USES COOKIES AND SIMILAR TECHNOLOGIES</h1>
<p>QuestGuard uses cookies and browser storage to:</p>
<ul>
<li>authenticate users;</li>
<li>maintain secure login sessions;</li>
<li>remember user preferences;</li>
<li>improve website performance;</li>
<li>reduce unnecessary network requests;</li>
<li>cache application data;</li>
<li>preserve unsaved work;</li>
<li>remember interface settings;</li>
<li>analyze usage of the Service;</li>
<li>improve reliability and functionality;</li>
<li>protect the Service against abuse, fraud, and malicious activity;</li>
<li>support future features and integrations.</li>
</ul>
<p>Cookies and similar technologies are not used to sell your personal information.</p>
<hr/>
<h1>3. LOCAL DEVICE STORAGE</h1>
<p>QuestGuard is a web application and relies heavily on browser storage technologies in addition to traditional cookies.</p>
<p>These technologies improve performance and user experience while reducing unnecessary downloads.</p>
<h2>Local Storage</h2>
<p>QuestGuard may use Local Storage to store information such as:</p>
<ul>
<li>application preferences;</li>
<li>interface settings;</li>
<li>theme preferences;</li>
<li>temporary drafts;</li>
<li>unpublished user-generated content;</li>
<li>game state;</li>
<li>locally cached information necessary to prevent accidental loss of work.</li>
</ul>
<p>For example, Local Storage may preserve changes while a user is editing content so that closing or refreshing the browser does not immediately result in lost work before the content is published.</p>
<p>Local Storage remains on your device until it is removed by you, overwritten by the application, or otherwise cleared by your browser.</p>
<hr/>
<h2>IndexedDB</h2>
<p>QuestGuard may use IndexedDB to store larger amounts of application data locally, including cached game content and downloadable resources.</p>
<p>Its purposes include:</p>
<ul>
<li>improving loading performance;</li>
<li>reducing repeated downloads;</li>
<li>minimizing bandwidth usage;</li>
<li>allowing portions of the Service to remain responsive even after temporary connectivity interruptions.</li>
</ul>
<p>Deleting IndexedDB data will not normally affect your Account but may require QuestGuard to download application data again.</p>
<hr/>
<h2>Session Storage</h2>
<p>QuestGuard may use Session Storage for temporary information required only during an active browser session.</p>
<p>Information stored in Session Storage is generally removed when the browser session ends.</p>
<hr/>
<h1>4. CATEGORIES OF COOKIES</h1>
<p>QuestGuard may use the following categories of cookies and similar technologies.</p>
<hr/>
<h2>Strictly Necessary Cookies</h2>
<p>These cookies are required for the operation of the Service.</p>
<p>They may be used to:</p>
<ul>
<li>authenticate users;</li>
<li>maintain login sessions;</li>
<li>protect against malicious activity;</li>
<li>provide security features;</li>
<li>balance network traffic;</li>
<li>remember security preferences;</li>
<li>ensure reliable operation of the Service.</li>
</ul>
<p>Without these technologies, portions of QuestGuard may not function correctly.</p>
<p>Because these cookies are necessary for the operation of the Service, they generally cannot be disabled through the cookie preference system.</p>
<hr/>
<h2>Functional Cookies</h2>
<p>Functional cookies improve usability by remembering information such as:</p>
<ul>
<li>interface preferences;</li>
<li>theme settings;</li>
<li>language preferences;</li>
<li>navigation preferences;</li>
<li>application state;</li>
<li>cached content;</li>
<li>user interface customization.</li>
</ul>
<p>These cookies enhance convenience but are generally not required for the basic operation of the Service.</p>
<hr/>
<h2>Analytics Cookies</h2>
<p>QuestGuard may use analytics technologies to understand how the Service is used.</p>
<p>These technologies may collect information including:</p>
<ul>
<li>pages viewed;</li>
<li>features used;</li>
<li>navigation patterns;</li>
<li>browser information;</li>
<li>approximate geographic region;</li>
<li>operating system;</li>
<li>device type;</li>
<li>session duration;</li>
<li>performance metrics;</li>
<li>error reports.</li>
</ul>
<p>QuestGuard currently plans to use Google Analytics and related Firebase analytics services.</p>
<p>Analytics technologies help us understand how the Service performs and identify opportunities for improvement.</p>
<p>Where required by applicable law, analytics cookies will only be used after obtaining your consent.</p>
<hr/>
<h2>Marketing Cookies</h2>
<p>QuestGuard does not currently use advertising or behavioral marketing cookies.</p>
<p>In the future, QuestGuard may integrate advertising or marketing platforms, including services such as Google Ads or similar providers.</p>
<p>Should such technologies be introduced, this Cookie Policy will be updated accordingly and, where required by applicable law, your consent will be obtained before such cookies are placed on your device.</p>
<hr/>
<h1>5. THIRD-PARTY SERVICES</h1>
<p>QuestGuard relies upon third-party providers that may place cookies or use similar technologies while providing services.</p>
<p>These providers may include:</p>
<ul>
<li>Google;</li>
<li>Firebase;</li>
<li>Google Analytics;</li>
<li>Cloudflare;</li>
<li>Stripe;</li>
<li>GitHub;</li>
<li>content delivery providers;</li>
<li>embedded media providers;</li>
<li>other infrastructure providers necessary for the operation of the Service.</li>
</ul>
<p>QuestGuard does not control the cookies placed by third-party providers acting under their own privacy policies.</p>
<p>Users are encouraged to review the privacy documentation of those providers.</p>
<hr/>
<h1>6. EMBEDDED THIRD-PARTY CONTENT</h1>
<p>Certain pages of the Service may include embedded content or links to third-party services.</p>
<p>Examples may include:</p>
<ul>
<li>YouTube videos;</li>
<li>Discord widgets;</li>
<li>GitHub-hosted resources;</li>
<li>externally hosted documentation;</li>
<li>payment providers;</li>
<li>other embedded media or interactive content.</li>
</ul>
<p>Such providers may place their own cookies or use similar technologies in accordance with their own policies.</p>
<p>QuestGuard has no control over these technologies.</p>
<hr/>
<h1>7. AUTHENTICATION</h1>
<p>QuestGuard currently uses Google Authentication through Firebase Authentication.</p>
<p>Authentication technologies may store information necessary to:</p>
<ul>
<li>maintain authenticated sessions;</li>
<li>remember signed-in users;</li>
<li>prevent unauthorized access;</li>
<li>improve security.</li>
</ul>
<p>Future versions of QuestGuard may also use additional authentication technologies, including secure session tokens, JSON Web Tokens (JWTs), or similar mechanisms where appropriate.</p>
<p>Such technologies will only be used to operate and secure the Service.</p>
<hr/>
<h1>8. COOKIE CONSENT</h1>
<p>Where required by applicable law, QuestGuard will request your consent before placing non-essential cookies on your device.</p>
<p>Users may generally choose to:</p>
<ul>
<li>accept all cookies;</li>
<li>reject non-essential cookies;</li>
<li>customize cookie preferences.</li>
</ul>
<p>You may change your preferences at any time through the cookie settings made available by the Service, where applicable.</p>
<p>Rejecting certain cookies may reduce the availability or functionality of some features.</p>
<hr/>
<h1>9. MANAGING COOKIES</h1>
<p>Most web browsers allow you to:</p>
<ul>
<li>view stored cookies;</li>
<li>delete cookies;</li>
<li>block cookies;</li>
<li>block third-party cookies;</li>
<li>clear Local Storage;</li>
<li>clear IndexedDB;</li>
<li>clear Session Storage.</li>
</ul>
<p>Removing cookies or browser storage may:</p>
<ul>
<li>sign you out of QuestGuard;</li>
<li>remove locally stored drafts;</li>
<li>remove cached content;</li>
<li>require downloaded resources to be downloaded again;</li>
<li>reset user preferences.</li>
</ul>
<p>Removing locally stored drafts or unpublished content may permanently delete information that has not yet been synchronized with the Service.</p>
<p>Users are encouraged to publish or otherwise back up important work before clearing browser storage.</p>
<hr/>
<h1>10. FUTURE TECHNOLOGIES</h1>
<p>QuestGuard is an actively evolving platform.</p>
<p>As new features, services, integrations, or infrastructure are introduced, additional cookies or browser storage technologies may become necessary.</p>
<p>Material changes to QuestGuard&#39;s use of cookies will be reflected in this Cookie Policy.</p>
<p>Where required by applicable law, additional consent will be obtained before introducing new categories of non-essential cookies.</p>
<hr/>
<h1>11. CHANGES TO THIS POLICY</h1>
<p>QuestGuard may update this Cookie Policy from time to time.</p>
<p>The most current version will always be made available through the Service.</p>
<p>Material changes may be communicated through the Service or by other reasonable means where appropriate.</p>
<p>Continued use of the Service following the effective date of an updated Cookie Policy constitutes acknowledgment of the revised Policy where permitted by applicable law.</p>
<h1>REFUND &amp; DIGITAL PRODUCTS POLICY</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>This Refund &amp; Digital Products Policy (&quot;<strong>Policy</strong>&quot;) explains how refunds, cancellations, purchases, and digital product licenses are handled by QuestGuard.</p>
<p>This Policy should be read together with the Terms of Service and Privacy Policy.</p>
<p>Nothing in this Policy limits any rights that cannot lawfully be limited under applicable consumer protection laws.</p>
<hr/>
<h1>1. GENERAL PRINCIPLES</h1>
<p>QuestGuard offers a combination of:</p>
<ul>
<li><p>digital Products;</p>
</li>
<li><p>premium access to online content;</p>
</li>
<li><p>downloadable files;</p>
</li>
<li><p>crowdfunding rewards;</p>
</li>
<li><p>physical products sold through third-party merchants.</p>
</li>
</ul>
<p>Because these Products are provided through different sales channels, different refund rules may apply depending on where the purchase was made.</p>
<p>Unless otherwise required by applicable law, all purchases are considered final after they have been successfully completed.</p>
<hr/>
<h1>2. DIGITAL PRODUCTS</h1>
<p>QuestGuard&#39;s digital Products may consist of one or more of the following:</p>
<ul>
<li><p>access to premium sections of the Service;</p>
</li>
<li><p>downloadable PDF publications;</p>
</li>
<li><p>downloadable digital assets;</p>
</li>
<li><p>digital tools;</p>
</li>
<li><p>activation of premium modules;</p>
</li>
<li><p>other digital content made available through QuestGuard.</p>
</li>
</ul>
<p>Purchasing a digital Product grants you a non-exclusive, non-transferable license to access and use that Product in accordance with the Terms of Service.</p>
<p>It does not transfer ownership of the Product or any associated intellectual property.</p>
<hr/>
<h1>3. NO REFUNDS FOR DIGITAL PRODUCTS</h1>
<p>Except where required by applicable law, purchases of digital Products are final and non-refundable.</p>
<p>Note that this is as such in order to protect us from possibly unfair purchases and abuse of our systems, and not from greed or because we want to keep your money. We want to offer our content in a fair way, and we expect a fair treatment of our products in return.</p>
<p>This applies whether the Product consists of:</p>
<ul>
<li><p>downloadable files;</p>
</li>
<li><p>premium website content;</p>
</li>
<li><p>digital unlocks;</p>
</li>
<li><p>activation codes;</p>
</li>
<li><p>premium modules;</p>
</li>
<li><p>access to online features.</p>
</li>
</ul>
<p>QuestGuard does not offer refunds simply because:</p>
<ul>
<li><p>you changed your mind;</p>
</li>
<li><p>you no longer wish to use the Product;</p>
</li>
<li><p>you did not fully use the Product;</p>
</li>
<li><p>you purchased the wrong Product;</p>
</li>
<li><p>your preferences changed after purchase.</p>
</li>
</ul>
<hr/>
<h1>4. DUPLICATE PURCHASES</h1>
<p>QuestGuard attempts to prevent duplicate purchases through the Service.</p>
<p>If, despite these safeguards, the same Product is accidentally purchased more than once for the same Account due to a technical error or duplicate transaction, QuestGuard may, at its discretion, issue a refund for the duplicate purchase after verifying the transaction.</p>
<hr/>
<h1>5. FAILED DIGITAL DELIVERY</h1>
<p>If payment is successfully completed but QuestGuard fails to grant the purchased digital entitlement due to a technical issue on QuestGuard&#39;s side, QuestGuard will make commercially reasonable efforts to resolve the issue.</p>
<p>If the issue cannot reasonably be resolved, QuestGuard may issue a refund or provide another appropriate remedy at its discretion or as required by applicable law.</p>
<hr/>
<h1>6. SERVICE AVAILABILITY</h1>
<p>QuestGuard uses commercially reasonable efforts to maintain the availability of the Service.</p>
<p>Temporary interruptions may occur due to:</p>
<ul>
<li><p>maintenance;</p>
</li>
<li><p>infrastructure failures;</p>
</li>
<li><p>cloud service outages;</p>
</li>
<li><p>denial-of-service attacks;</p>
</li>
<li><p>cybersecurity incidents;</p>
</li>
<li><p>internet failures;</p>
</li>
<li><p>force majeure events;</p>
</li>
<li><p>circumstances beyond QuestGuard&#39;s reasonable control.</p>
</li>
</ul>
<p>Temporary unavailability of the Service does not entitle Users to a refund.</p>
<p>QuestGuard does not guarantee uninterrupted access to the Service.</p>
<hr/>
<h1>7. PERMANENT DISCONTINUATION</h1>
<p>QuestGuard is intended to be a long-term commercial platform.</p>
<p>However, circumstances may arise where continued operation is no longer commercially or technically feasible.</p>
<p>If QuestGuard permanently discontinues the Service, previously purchased digital Products shall not automatically become refundable solely because the Service has ceased operating.</p>
<p>Where reasonably practical, QuestGuard will make good faith efforts to provide advance notice of any permanent shutdown.</p>
<hr/>
<h1>8. KICKSTARTER CAMPAIGNS</h1>
<p>Products obtained through Kickstarter are governed both by:</p>
<ul>
<li><p>Kickstarter&#39;s Terms of Use; and</p>
</li>
<li><p>the specific terms of the applicable crowdfunding campaign.</p>
</li>
</ul>
<p>Kickstarter is a crowdfunding platform and is not a retail store. Kickstarter does not issue refunds on behalf of creators.</p>
<p>Before a Kickstarter campaign ends, backers may generally cancel their pledge through Kickstarter in accordance with Kickstarter&#39;s platform rules.</p>
<p>After a campaign has successfully concluded and payment collection has begun, refund requests must be submitted directly to QuestGuard.</p>
<p>Refund requests relating to Kickstarter campaigns will be considered in light of:</p>
<ul>
<li><p>the applicable campaign terms;</p>
</li>
<li><p>the stage of project fulfillment;</p>
</li>
<li><p>whether rewards have already been produced or delivered;</p>
</li>
<li><p>applicable law;</p>
</li>
<li><p>the specific circumstances of the request.</p>
</li>
</ul>
<p>QuestGuard reserves the right to approve or deny such requests where permitted by applicable law.</p>
<hr/>
<h1>9. TEMPORARY CAMPAIGN ACCESS</h1>
<p>QuestGuard may provide temporary activation codes, early-access credentials, beta access, preview access, or other campaign-specific access during crowdfunding campaigns.</p>
<p>Such temporary access may expire or be replaced following campaign fulfillment.</p>
<p>Where applicable, QuestGuard may replace temporary campaign access with permanent entitlements corresponding to the rewards earned by each eligible backer.</p>
<p>Expiration or replacement of temporary access credentials does not constitute a revocation of a purchased reward where permanent access is subsequently granted in accordance with the applicable campaign.</p>
<hr/>
<h1>10. PHYSICAL PRODUCTS</h1>
<p>Certain physical Products may be sold through third-party merchants, distributors, publishers, print-on-demand providers, or other Merchants of Record.</p>
<p>Where a third party acts as the Merchant of Record, that party is responsible for:</p>
<ul>
<li><p>payment processing;</p>
</li>
<li><p>order management;</p>
</li>
<li><p>shipping;</p>
</li>
<li><p>returns;</p>
</li>
<li><p>refunds;</p>
</li>
<li><p>customer service relating to the purchase transaction.</p>
</li>
</ul>
<p>Refunds for such purchases are governed by the applicable Merchant of Record&#39;s policies.</p>
<p>QuestGuard cannot issue refunds for purchases where it is not the Merchant of Record unless otherwise expressly agreed.</p>
<hr/>
<h1>11. THIRD-PARTY STORES</h1>
<p>QuestGuard Products may also be made available through third-party marketplaces or storefronts.</p>
<p>Where Products are purchased through a third-party platform, refunds are governed by that platform&#39;s applicable terms and refund policies.</p>
<hr/>
<h1>12. CHARGEBACKS</h1>
<p>If a payment is reversed through a chargeback, payment dispute, or similar process after digital access has been granted, QuestGuard reserves the right to:</p>
<ul>
<li><p>suspend or terminate the applicable Account;</p>
</li>
<li><p>revoke access to the affected Product;</p>
</li>
<li><p>deactivate associated activation codes;</p>
</li>
<li><p>investigate suspected fraud;</p>
</li>
<li><p>take appropriate legal or administrative action where necessary.</p>
</li>
</ul>
<p>Nothing in this section limits any rights Users may have to initiate legitimate payment disputes under applicable law.</p>
<hr/>
<h1>13. FRAUDULENT OR IMPROPER PURCHASES</h1>
<p>QuestGuard reserves the right to refuse refunds or revoke access where purchases were obtained through:</p>
<ul>
<li><p>fraud;</p>
</li>
<li><p>stolen payment methods;</p>
</li>
<li><p>unauthorized use of payment credentials;</p>
</li>
<li><p>abuse of promotional offers;</p>
</li>
<li><p>technical manipulation;</p>
</li>
<li><p>violation of the Terms of Service.</p>
</li>
</ul>
<hr/>
<h1>14. EFFECT OF A REFUND</h1>
<p>Where QuestGuard issues a refund for a Product, the license granted for that Product automatically terminates unless otherwise expressly stated.</p>
<p>Upon receiving a refund, the User must immediately cease using the refunded Product and permanently delete any downloaded copies, except where retention is required by applicable law.</p>
<p>QuestGuard may revoke associated activation codes, premium entitlements, and online access following a refund.</p>
<hr/>
<h1>15. PROMOTIONAL CODES</h1>
<p>Promotional codes, activation codes, Kickstarter reward codes, beta invitations, giveaway codes, and similar offers:</p>
<ul>
<li><p>may have expiration dates;</p>
</li>
<li><p>may be subject to eligibility requirements;</p>
</li>
<li><p>may be limited in quantity;</p>
</li>
<li><p>may be non-transferable;</p>
</li>
<li><p>have no cash value unless expressly stated otherwise.</p>
</li>
</ul>
<p>QuestGuard reserves the right to cancel promotional codes that were issued in error or obtained through misuse, fraud, or violation of the Terms of Service.</p>
<hr/>
<h1>16. CONTACT</h1>
<p>Questions regarding refunds or purchases may be directed to QuestGuard using the contact information provided in the Contact Information section of this Legal document.</p>
<h1>COMMUNITY CONTENT &amp; INTELLECTUAL PROPERTY POLICY</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>This Community Content &amp; Intellectual Property Policy (&quot;<strong>Policy</strong>&quot;) governs the creation, upload, publication, sharing, moderation, and use of User Content within QuestGuard.</p>
<p>This Policy should be read together with the Terms of Service, Privacy Policy, Cookie Policy, and other legal documents governing the Service.</p>
<p>Nothing in this Policy transfers ownership of original User Content to QuestGuard unless expressly stated otherwise.</p>
<hr/>
<h1>1. PURPOSE</h1>
<p>QuestGuard is intended to encourage creativity, collaboration, and the creation of original tabletop roleplaying game content.</p>
<p>This Policy explains:</p>
<ul>
<li><p>who owns User Content;</p>
</li>
<li><p>what rights Users grant to QuestGuard;</p>
</li>
<li><p>what content may not be uploaded;</p>
</li>
<li><p>how intellectual property is respected;</p>
</li>
<li><p>how moderation is handled;</p>
</li>
<li><p>how copyright complaints are addressed.</p>
</li>
</ul>
<hr/>
<h1>2. OWNERSHIP OF USER CONTENT</h1>
<p>QuestGuard does not claim ownership of original User Content created by Users.</p>
<p>Subject to these Terms and applicable law, Users retain ownership of their original creative works, including but not limited to:</p>
<ul>
<li><p>adventures;</p>
</li>
<li><p>encounters;</p>
</li>
<li><p>monsters;</p>
</li>
<li><p>items;</p>
</li>
<li><p>characters;</p>
</li>
<li><p>maps;</p>
</li>
<li><p>settings;</p>
</li>
<li><p>worlds;</p>
</li>
<li><p>lore;</p>
</li>
<li><p>notes;</p>
</li>
<li><p>homebrew mechanics;</p>
</li>
<li><p>custom rules;</p>
</li>
<li><p>artwork created by the User;</p>
</li>
<li><p>original written material;</p>
</li>
<li><p>other original creative works.</p>
</li>
</ul>
<p>Users are solely responsible for ensuring that such content is original or that they possess all necessary rights to upload, publish, and distribute it.</p>
<hr/>
<h1>3. LICENSE GRANTED TO QUESTGUARD</h1>
<p>By uploading or publishing User Content, the User grants QuestGuard a worldwide, non-exclusive, royalty-free license to:</p>
<ul>
<li><p>host;</p>
</li>
<li><p>store;</p>
</li>
<li><p>reproduce;</p>
</li>
<li><p>process;</p>
</li>
<li><p>display;</p>
</li>
<li><p>transmit;</p>
</li>
<li><p>synchronize;</p>
</li>
<li><p>cache;</p>
</li>
<li><p>back up;</p>
</li>
<li><p>technically modify;</p>
</li>
<li><p>generate previews;</p>
</li>
<li><p>format for display;</p>
</li>
<li><p>distribute within the Service;</p>
</li>
</ul>
<p>solely for the purpose of operating, maintaining, improving, securing, promoting, and providing the Service.</p>
<p>QuestGuard does not acquire ownership of User Content through this license.</p>
<hr/>
<h1>4. PUBLICLY SHARED CONTENT</h1>
<p>Where a User intentionally makes User Content publicly available through the Service, QuestGuard may additionally:</p>
<ul>
<li><p>feature it;</p>
</li>
<li><p>recommend it;</p>
</li>
<li><p>include it in community showcases;</p>
</li>
<li><p>display screenshots;</p>
</li>
<li><p>publish excerpts;</p>
</li>
<li><p>include it in newsletters;</p>
</li>
<li><p>display it on social media;</p>
</li>
<li><p>reference it in presentations, livestreams, videos, articles, promotional materials, or demonstrations relating to QuestGuard.</p>
</li>
</ul>
<p>No royalties or additional compensation shall be owed for such uses.</p>
<p>QuestGuard will make good faith efforts to attribute publicly featured User Content to its creator where reasonably practical.</p>
<hr/>
<h1>5. ORIGINALITY</h1>
<p>Users represent that they possess all necessary rights to upload the content they publish.</p>
<p>Users may not knowingly upload content that:</p>
<ul>
<li><p>infringes another person&#39;s copyright;</p>
</li>
<li><p>infringes trademarks;</p>
</li>
<li><p>infringes patents;</p>
</li>
<li><p>infringes publicity rights;</p>
</li>
<li><p>infringes privacy rights;</p>
</li>
<li><p>otherwise violates applicable intellectual property laws.</p>
</li>
</ul>
<p>QuestGuard does not proactively review or verify every uploaded work.</p>
<p>Responsibility for uploaded content remains with the User.</p>
<hr/>
<h1>6. QUESTGUARD INTELLECTUAL PROPERTY</h1>
<p>Except for User Content owned by Users, all QuestGuard intellectual property remains the exclusive property of GRIFFINCRAFT S.R.L.</p>
<p>This includes, without limitation:</p>
<ul>
<li><p>official rules;</p>
</li>
<li><p>official adventures;</p>
</li>
<li><p>official classes;</p>
</li>
<li><p>official races;</p>
</li>
<li><p>official monsters;</p>
</li>
<li><p>official lore;</p>
</li>
<li><p>official artwork;</p>
</li>
<li><p>logos;</p>
</li>
<li><p>branding;</p>
</li>
<li><p>software;</p>
</li>
<li><p>databases;</p>
</li>
<li><p>source code;</p>
</li>
<li><p>downloadable publications;</p>
</li>
<li><p>premium Products;</p>
</li>
<li><p>layouts;</p>
</li>
<li><p>icons;</p>
</li>
<li><p>user interface elements;</p>
</li>
<li><p>trademarks.</p>
</li>
</ul>
<p>Nothing in this Policy grants permission to reproduce or redistribute QuestGuard intellectual property except where expressly authorized.</p>
<hr/>
<h1>7. HOMEBREW CONTENT</h1>
<p>QuestGuard encourages Users to create original homebrew content.</p>
<p>Users remain free to:</p>
<ul>
<li><p>publish homebrew;</p>
</li>
<li><p>distribute homebrew;</p>
</li>
<li><p>sell homebrew;</p>
</li>
<li><p>license homebrew;</p>
</li>
<li><p>commercially exploit their own original creations.</p>
</li>
</ul>
<p>However, User Content must not be used to:</p>
<ul>
<li><p>reproduce official QuestGuard Products;</p>
</li>
<li><p>substantially recreate premium QuestGuard content;</p>
</li>
<li><p>reconstruct paid Products;</p>
</li>
<li><p>circumvent paid access restrictions;</p>
</li>
<li><p>redistribute premium QuestGuard materials under the guise of homebrew.</p>
</li>
</ul>
<p>QuestGuard reserves the right to remove such content and take appropriate enforcement action.</p>
<hr/>
<h1>8. QUESTGUARD COMPATIBILITY</h1>
<p>Users may truthfully describe their original works as being compatible with QuestGuard.</p>
<p>However, Users may not imply or represent that:</p>
<ul>
<li><p>QuestGuard officially created the work;</p>
</li>
<li><p>QuestGuard officially endorsed the work;</p>
</li>
<li><p>GRIFFINCRAFT S.R.L. sponsors the work;</p>
</li>
<li><p>the work forms part of QuestGuard&#39;s official publications,</p>
</li>
</ul>
<p>unless such authorization has been expressly granted.</p>
<hr/>
<h1>9. ARTIFICIAL INTELLIGENCE</h1>
<p>QuestGuard permits the publication of AI-assisted or AI-generated artwork and creative content, provided that the User possesses all necessary rights to publish such material.</p>
<p>QuestGuard may remove content consisting primarily of mass-produced, automated, or spam-like AI-generated material where such content negatively impacts the quality or integrity of the Service.</p>
<p>QuestGuard does not use private User Content to train artificial intelligence models without the User&#39;s explicit consent.</p>
<hr/>
<h1>10. EXTERNAL CONTENT</h1>
<p>User Content may include references or links to third-party resources, including websites, portfolios, social media profiles, videos, communities, or other projects.</p>
<p>Users remain solely responsible for the content accessible through such links.</p>
<p>QuestGuard may remove links that:</p>
<ul>
<li><p>distribute malware;</p>
</li>
<li><p>facilitate phishing;</p>
</li>
<li><p>distribute malicious software;</p>
</li>
<li><p>violate applicable law;</p>
</li>
<li><p>materially threaten the security or integrity of the Service.</p>
</li>
</ul>
<p>QuestGuard does not endorse third-party websites merely because Users reference them.</p>
<hr/>
<h1>11. PROHIBITED CONTENT</h1>
<p>Users may not knowingly upload content that:</p>
<ul>
<li><p>constitutes spam;</p>
</li>
<li><p>distributes malware;</p>
</li>
<li><p>contains viruses or malicious software;</p>
</li>
<li><p>facilitates unauthorized access to computer systems;</p>
</li>
<li><p>promotes illegal activity;</p>
</li>
<li><p>constitutes unlawful harassment;</p>
</li>
<li><p>contains hate speech prohibited by applicable law;</p>
</li>
<li><p>contains real-world graphic gore;</p>
</li>
<li><p>is designed primarily to deceive, manipulate, or abuse the Service through automated generation or spam techniques.</p>
</li>
</ul>
<p>QuestGuard generally adopts a hands-off moderation philosophy and does not review all uploaded content before publication.</p>
<p>The existence of prohibited content on the Service does not imply approval or endorsement by QuestGuard.</p>
<hr/>
<h1>12. MATURE CONTENT</h1>
<p>QuestGuard does not generally prohibit mature fictional themes, including fantasy violence, references to alcohol, tobacco, politics, or consensual adult subject matter.</p>
<p>However, QuestGuard reserves the right to restrict, remove, or decline to feature content where it reasonably believes such content:</p>
<ul>
<li><p>violates applicable law;</p>
</li>
<li><p>materially harms the community;</p>
</li>
<li><p>endangers users;</p>
</li>
<li><p>is excessively graphic;</p>
</li>
<li><p>primarily exists to shock, harass, or abuse other users;</p>
</li>
<li><p>would reasonably damage the reputation or integrity of the Service.</p>
</li>
</ul>
<hr/>
<h1>13. MODERATION</h1>
<p>QuestGuard generally operates as a platform rather than a publisher.</p>
<p>QuestGuard does not undertake a general obligation to monitor, review, or verify all User Content.</p>
<p>Nevertheless, QuestGuard reserves the right, at its sole discretion, to:</p>
<ul>
<li><p>remove User Content;</p>
</li>
<li><p>restrict visibility;</p>
</li>
<li><p>suspend Accounts;</p>
</li>
<li><p>terminate Accounts;</p>
</li>
<li><p>investigate reports;</p>
</li>
<li><p>comply with lawful requests from public authorities;</p>
</li>
<li><p>protect the integrity of the Service.</p>
</li>
</ul>
<p>QuestGuard may exercise these rights with or without prior notice where permitted by applicable law.</p>
<hr/>
<h1>14. COPYRIGHT COMPLAINTS</h1>
<p>If you believe that User Content infringes your intellectual property rights, you may contact QuestGuard using the contact information provided in this Legal document.</p>
<p>Your notice should include sufficient information to reasonably identify:</p>
<ul>
<li><p>the allegedly infringed work;</p>
</li>
<li><p>the allegedly infringing content;</p>
</li>
<li><p>your ownership or authority to act;</p>
</li>
<li><p>your contact information;</p>
</li>
<li><p>any additional information reasonably necessary to investigate the complaint.</p>
</li>
</ul>
<p>QuestGuard will review such notices in good faith and may remove or restrict access to allegedly infringing material where appropriate.</p>
<p>QuestGuard reserves the right to request additional information before taking action.</p>
<hr/>
<h1>15. COMMUNITY FEATURES</h1>
<p>QuestGuard may introduce features allowing Users to:</p>
<ul>
<li><p>publish creations;</p>
</li>
<li><p>share content;</p>
</li>
<li><p>collaborate;</p>
</li>
<li><p>rate content;</p>
</li>
<li><p>review content;</p>
</li>
<li><p>comment;</p>
</li>
<li><p>curate collections;</p>
</li>
<li><p>operate marketplaces;</p>
</li>
<li><p>distribute commercial works.</p>
</li>
</ul>
<p>Additional rules governing such features may be introduced as those features become available.</p>
<hr/>
<h1>16. FEATURED CONTENT</h1>
<p>QuestGuard may curate and showcase community-created content.</p>
<p>Selection for featured content is entirely at QuestGuard&#39;s discretion and may take into account factors including:</p>
<ul>
<li><p>originality;</p>
</li>
<li><p>creativity;</p>
</li>
<li><p>technical quality;</p>
</li>
<li><p>usefulness;</p>
</li>
<li><p>community reception;</p>
</li>
<li><p>editorial considerations;</p>
</li>
<li><p>suitability for the Service.</p>
</li>
</ul>
<p>Being featured is a privilege rather than an entitlement.</p>
<p>QuestGuard may remove featured status at any time.</p>
<hr/>
<h1>17. FEEDBACK</h1>
<p>Users may voluntarily submit ideas, suggestions, feature requests, bug reports, design proposals, balance suggestions, or other feedback.</p>
<p>Unless otherwise agreed in writing, QuestGuard may freely use, implement, modify, or incorporate such feedback without restriction or compensation.</p>
<p>No ownership or intellectual property rights in QuestGuard are transferred through the submission of feedback.</p>
<hr/>
<h1>18. REMOVAL OF USER CONTENT</h1>
<p>Users may remove or delete their own User Content where the functionality of the Service permits.</p>
<p>Deletion of User Content does not necessarily require immediate removal from:</p>
<ul>
<li><p>system backups;</p>
</li>
<li><p>cached copies under the User&#39;s control;</p>
</li>
<li><p>archival records maintained for operational or legal purposes.</p>
</li>
</ul>
<p>Where User Content has previously been featured in promotional materials, QuestGuard may continue to use existing promotional materials already produced, although QuestGuard may, where reasonably practical, discontinue future promotional use following removal of the underlying content.</p>
<hr/>
<h1>19. FUTURE MARKETPLACE</h1>
<p>QuestGuard may introduce community marketplaces or commercial distribution platforms in the future.</p>
<p>Unless otherwise specified, this Policy shall continue to govern User Content made available through such features.</p>
<p>Additional marketplace-specific terms may supplement this Policy.</p>
<hr/>
<h1>20. DON&#39;T BE A JERK</h1>
<p>QuestGuard exists to help people create and enjoy tabletop roleplaying games.</p>
<p>Users are expected to interact with one another respectfully, contribute in good faith, and avoid conduct intended primarily to harass, disrupt, or diminish the experience of others.</p>
<p>Not every disagreement requires moderation, and not every unpleasant interaction constitutes a violation of this Policy. QuestGuard generally prefers to give Users the freedom to create, share, and express themselves responsibly.</p>
<p>We encourage creativity, constructive collaboration, and mutual respect within the community.</p>
<hr/>
<h1>21. CHANGES TO THIS POLICY</h1>
<p>QuestGuard may update this Policy from time to time as the Service evolves.</p>
<p>Material changes may be communicated through the Service or by other reasonable means where appropriate.</p>
<p>Continued use of the Service after such changes take effect constitutes acceptance of the revised Policy where permitted by applicable law.</p>
<h1>ACCEPTABLE USE POLICY</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>This Acceptable Use Policy (&quot;<strong>Policy</strong>&quot;) establishes the rules governing acceptable use of QuestGuard&#39;s infrastructure, software, networks, and related services.</p>
<p>This Policy supplements the Terms of Service. In the event of any conflict between this Policy and the Terms of Service, the Terms of Service shall prevail.</p>
<hr/>
<h1>1. PURPOSE</h1>
<p>QuestGuard is intended to provide a reliable, secure, and enjoyable platform for tabletop roleplaying games.</p>
<p>Users are expected to use the Service responsibly and in a manner that does not interfere with the experience of others or compromise the security, integrity, or availability of the Service.</p>
<hr/>
<h1>2. SECURITY</h1>
<p>You must not attempt to:</p>
<ul>
<li><p>gain unauthorized access to any portion of the Service;</p>
</li>
<li><p>access another User&#39;s Account or data without authorization;</p>
</li>
<li><p>bypass authentication or authorization mechanisms;</p>
</li>
<li><p>interfere with the security of the Service;</p>
</li>
<li><p>probe, scan, or test the vulnerability of the Service without prior written permission;</p>
</li>
<li><p>circumvent security measures or technical restrictions;</p>
</li>
<li><p>exploit bugs, vulnerabilities, or security flaws for unauthorized purposes.</p>
</li>
</ul>
<p>If you discover a security vulnerability, we encourage you to report it responsibly using the contact information provided in this Legal document. Please do not publicly disclose security vulnerabilities until QuestGuard has had a reasonable opportunity to investigate and address them.</p>
<hr/>
<h1>3. AUTOMATED ACCESS</h1>
<p>Unless expressly authorized by QuestGuard, you must not use automated means to:</p>
<ul>
<li><p>scrape or harvest content;</p>
</li>
<li><p>create Accounts;</p>
</li>
<li><p>access premium content;</p>
</li>
<li><p>collect user information;</p>
</li>
<li><p>bypass access controls;</p>
</li>
<li><p>perform large-scale automated requests;</p>
</li>
<li><p>train artificial intelligence models using QuestGuard content;</p>
</li>
<li><p>interfere with the normal operation of the Service.</p>
</li>
</ul>
<p>Reasonable indexing by legitimate search engines is permitted unless otherwise restricted.</p>
<hr/>
<h1>4. RESOURCE ABUSE</h1>
<p>You must not intentionally:</p>
<ul>
<li><p>overload QuestGuard&#39;s infrastructure;</p>
</li>
<li><p>consume excessive server resources;</p>
</li>
<li><p>interfere with the availability of the Service;</p>
</li>
<li><p>launch denial-of-service or distributed denial-of-service attacks;</p>
</li>
<li><p>abuse caching mechanisms;</p>
</li>
<li><p>repeatedly trigger automated systems in a manner likely to degrade performance;</p>
</li>
<li><p>use the Service for cryptocurrency mining or similar computational activities unrelated to its intended purpose.</p>
</li>
</ul>
<hr/>
<h1>5. MALICIOUS SOFTWARE</h1>
<p>You must not upload, distribute, transmit, or otherwise make available:</p>
<ul>
<li><p>malware;</p>
</li>
<li><p>viruses;</p>
</li>
<li><p>ransomware;</p>
</li>
<li><p>spyware;</p>
</li>
<li><p>trojans;</p>
</li>
<li><p>malicious scripts;</p>
</li>
<li><p>code intended to damage or disrupt the Service or third-party systems.</p>
</li>
</ul>
<hr/>
<h1>6. INTERFERENCE WITH THE SERVICE</h1>
<p>You must not intentionally interfere with the operation of the Service or the experience of other Users.</p>
<p>Examples include:</p>
<ul>
<li><p>disrupting normal platform functionality;</p>
</li>
<li><p>intentionally triggering errors;</p>
</li>
<li><p>interfering with another User&#39;s access;</p>
</li>
<li><p>attempting to disable or circumvent platform features;</p>
</li>
<li><p>using the Service in a manner inconsistent with its intended purpose.</p>
</li>
</ul>
<hr/>
<h1>7. APIs AND FUTURE SERVICES</h1>
<p>QuestGuard may introduce APIs, integrations, plugins, automation tools, or developer services in the future.</p>
<p>Where such services are provided, they may be subject to additional documentation, technical limitations, authentication requirements, rate limits, or separate terms.</p>
<p>Users must comply with any applicable requirements governing such services.</p>
<hr/>
<h1>8. FAIR USE</h1>
<p>QuestGuard is intended to be used in good faith.</p>
<p>Users should avoid conduct that, while not expressly prohibited elsewhere, is reasonably likely to:</p>
<ul>
<li><p>disrupt the operation of the Service;</p>
</li>
<li><p>impose unnecessary operational costs;</p>
</li>
<li><p>degrade the experience of other Users;</p>
</li>
<li><p>circumvent intended limitations;</p>
</li>
<li><p>undermine the security or integrity of QuestGuard.</p>
</li>
</ul>
<p>QuestGuard reserves the right to take reasonable measures to protect the stability, security, and reliability of the Service.</p>
<hr/>
<h1>9. ENFORCEMENT</h1>
<p>Violation of this Policy may result in one or more of the following actions, as appropriate and where permitted by applicable law:</p>
<ul>
<li><p>warnings;</p>
</li>
<li><p>temporary restrictions;</p>
</li>
<li><p>suspension of access;</p>
</li>
<li><p>removal of offending content;</p>
</li>
<li><p>revocation of access to Products or features;</p>
</li>
<li><p>permanent termination of Accounts;</p>
</li>
<li><p>legal action where appropriate.</p>
</li>
</ul>
<p>QuestGuard will generally seek to enforce this Policy in a reasonable and proportionate manner, taking into account the nature, severity, and circumstances of the violation.</p>
<hr/>
<h1>10. CHANGES TO THIS POLICY</h1>
<p>QuestGuard may update this Policy from time to time as the Service evolves.</p>
<p>Material changes may be communicated through the Service or by other reasonable means where appropriate.</p>
<p>Continued use of the Service after such changes take effect constitutes acceptance of the revised Policy where permitted by applicable law.</p>
<h1>CREATOR LICENSE &amp; TRADEMARK GUIDELINES</h1>
<p><strong>Last Updated:</strong> July 31, 2026</p>
<p>QuestGuard is designed to be a living tabletop roleplaying game supported by an active and creative community. We encourage players, Game Masters, artists, writers, publishers, content creators, and developers to create original works inspired by QuestGuard.</p>
<p>These Creator License &amp; Trademark Guidelines (&quot;<strong>Guidelines</strong>&quot;) explain what you may do with QuestGuard, what you may not do, and how you may refer to QuestGuard in your own creations.</p>
<p>These Guidelines supplement the Terms of Service and all other legal documents governing QuestGuard.</p>
<hr/>
<h1>1. PURPOSE</h1>
<p>Our goal is to encourage a thriving creative ecosystem while protecting the integrity of QuestGuard&#39;s official products, intellectual property, and community.</p>
<p>Unless otherwise stated, these Guidelines grant permission to create original third-party content inspired by QuestGuard.</p>
<p>These Guidelines do not transfer ownership of QuestGuard&#39;s intellectual property.</p>
<hr/>
<h1>2. WHAT YOU MAY CREATE</h1>
<p>Subject to these Guidelines, you may create original third-party content compatible with QuestGuard, including but not limited to:</p>
<ul>
<li><p>adventures;</p>
</li>
<li><p>encounters;</p>
</li>
<li><p>settings;</p>
</li>
<li><p>worlds;</p>
</li>
<li><p>lore;</p>
</li>
<li><p>monsters;</p>
</li>
<li><p>items;</p>
</li>
<li><p>classes;</p>
</li>
<li><p>subclasses;</p>
</li>
<li><p>abilities;</p>
</li>
<li><p>homebrew rules;</p>
</li>
<li><p>supplements;</p>
</li>
<li><p>campaign books;</p>
</li>
<li><p>digital tools that do not require unauthorized access to QuestGuard systems;</p>
</li>
<li><p>virtual tabletop content;</p>
</li>
<li><p>videos;</p>
</li>
<li><p>livestreams;</p>
</li>
<li><p>podcasts;</p>
</li>
<li><p>blogs;</p>
</li>
<li><p>reviews;</p>
</li>
<li><p>tutorials;</p>
</li>
<li><p>articles;</p>
</li>
<li><p>printable materials;</p>
</li>
<li><p>commercial publications.</p>
</li>
</ul>
<p>You retain ownership of your original work.</p>
<hr/>
<h1>3. COMMERCIAL USE</h1>
<p>You may sell your original QuestGuard-compatible content.</p>
<p>Examples include:</p>
<ul>
<li><p>digital adventures;</p>
</li>
<li><p>printed books;</p>
</li>
<li><p>encounter collections;</p>
</li>
<li><p>homebrew supplements;</p>
</li>
<li><p>original artwork;</p>
</li>
<li><p>original settings;</p>
</li>
<li><p>printable accessories;</p>
</li>
<li><p>virtual tabletop modules.</p>
</li>
</ul>
<p>QuestGuard does not claim ownership of such original works.</p>
<hr/>
<h1>4. QUESTGUARD COMPATIBILITY</h1>
<p>You may truthfully describe your work as:</p>
<ul>
<li><p>&quot;Compatible with QuestGuard&quot;</p>
</li>
<li><p>&quot;Designed for QuestGuard&quot;</p>
</li>
<li><p>&quot;For use with QuestGuard&quot;</p>
</li>
</ul>
<p>You may not state or imply that your work is:</p>
<ul>
<li><p>official;</p>
</li>
<li><p>licensed by GRIFFINCRAFT S.R.L.;</p>
</li>
<li><p>endorsed by QuestGuard;</p>
</li>
<li><p>approved by QuestGuard;</p>
</li>
<li><p>published by QuestGuard;</p>
</li>
</ul>
<p>unless you have received express written authorization.</p>
<hr/>
<h1>5. REQUIRED DISCLAIMER</h1>
<p>Any publicly distributed or commercially released QuestGuard-compatible work should prominently include a disclaimer substantially similar to the following:</p>
<blockquote>
<p>&quot;This product is compatible with QuestGuard but is not affiliated with, sponsored, endorsed, or approved by GRIFFINCRAFT S.R.L. or QuestGuard.&quot;</p>
</blockquote>
<p>Equivalent wording conveying the same meaning is acceptable.</p>
<hr/>
<h1>6. QUESTGUARD INTELLECTUAL PROPERTY</h1>
<p>GRIFFINCRAFT S.R.L. retains all rights in QuestGuard&#39;s intellectual property, including but not limited to:</p>
<ul>
<li><p>official rules;</p>
</li>
<li><p>official adventures;</p>
</li>
<li><p>official classes;</p>
</li>
<li><p>official races;</p>
</li>
<li><p>official monsters;</p>
</li>
<li><p>official lore;</p>
</li>
<li><p>official artwork;</p>
</li>
<li><p>page layouts;</p>
</li>
<li><p>icons;</p>
</li>
<li><p>logos;</p>
</li>
<li><p>branding;</p>
</li>
<li><p>downloadable publications;</p>
</li>
<li><p>premium Products;</p>
</li>
<li><p>website content;</p>
</li>
<li><p>software;</p>
</li>
<li><p>databases;</p>
</li>
<li><p>source code.</p>
</li>
</ul>
<p>Except as expressly permitted by these Guidelines or applicable law, these materials may not be copied, redistributed, or incorporated into third-party works.</p>
<hr/>
<h1>7. ORIGINALITY</h1>
<p>Third-party works should be original.</p>
<p>You may create works inspired by QuestGuard.</p>
<p>You may not reproduce, substantially imitate, reconstruct, or otherwise circumvent access to official QuestGuard content, whether free or paid.</p>
<p>In particular, you may not:</p>
<ul>
<li><p>recreate official QuestGuard Products;</p>
</li>
<li><p>manually reproduce premium content as homebrew;</p>
</li>
<li><p>rebuild official databases;</p>
</li>
<li><p>copy official rule text;</p>
</li>
<li><p>redistribute official downloadable materials;</p>
</li>
<li><p>use community content to circumvent paid access.</p>
</li>
</ul>
<p>The purpose of these Guidelines is to encourage new creations—not to reproduce existing official material.</p>
<hr/>
<h1>8. OFFICIAL ARTWORK AND VISUAL ASSETS</h1>
<p>Unless expressly provided by QuestGuard for community use, you may not use:</p>
<ul>
<li><p>official artwork;</p>
</li>
<li><p>official logos;</p>
</li>
<li><p>official page designs;</p>
</li>
<li><p>official icons;</p>
</li>
<li><p>official illustrations;</p>
</li>
<li><p>official graphic assets.</p>
</li>
</ul>
<p>QuestGuard may make certain assets available for community use through designated community resources.</p>
<p>Only those assets may be used in accordance with any accompanying terms.</p>
<hr/>
<h1>9. VIDEOS, STREAMS, AND REVIEWS</h1>
<p>You are welcome to create:</p>
<ul>
<li><p>livestreams;</p>
</li>
<li><p>actual play series;</p>
</li>
<li><p>podcasts;</p>
</li>
<li><p>tutorials;</p>
</li>
<li><p>reviews;</p>
</li>
<li><p>educational content;</p>
</li>
<li><p>news coverage;</p>
</li>
<li><p>commentary;</p>
</li>
<li><p>entertainment content.</p>
</li>
</ul>
<p>Such content may be monetized through advertising, sponsorships, memberships, donations, or similar lawful means.</p>
<p>Reviewers may display excerpts or pages from official publications where reasonably necessary for review, commentary, criticism, or similar purposes permitted by applicable law.</p>
<p>However, premium publications should not be reproduced in a manner that substitutes for purchasing the official Product.</p>
<hr/>
<h1>10. SCREENSHOTS</h1>
<p>Screenshots of publicly available QuestGuard content may be used for discussion, tutorials, reviews, commentary, or educational purposes.</p>
<p>Screenshots of premium content should not be distributed in a manner that materially substitutes for purchasing that content.</p>
<hr/>
<h1>11. VIRTUAL TABLETOPS</h1>
<p>Original QuestGuard-compatible content may be published for virtual tabletop platforms.</p>
<p>Such content must comply with these Guidelines and must not reproduce official QuestGuard Products.</p>
<hr/>
<h1>12. CHARACTER BUILDERS AND AUTOMATED TOOLS</h1>
<p>QuestGuard includes integrated official digital tools.</p>
<p>Accordingly, third parties may not create or distribute tools that rely upon unauthorized scraping, automated extraction, copying, or reconstruction of QuestGuard&#39;s official website, databases, or proprietary systems.</p>
<p>Nothing in this section prevents the creation of independent utilities that do not rely upon unauthorized access to QuestGuard&#39;s protected content or infrastructure.</p>
<hr/>
<h1>13. TRANSLATIONS</h1>
<p>Official translations of QuestGuard may only be published by GRIFFINCRAFT S.R.L. or with its express written authorization.</p>
<p>Unofficial translations of official QuestGuard materials may not be distributed without permission.</p>
<p>Nothing prevents creators from writing original content in any language.</p>
<hr/>
<h1>14. ARTIFICIAL INTELLIGENCE</h1>
<p>QuestGuard&#39;s official publications, artwork, databases, and other official materials may not be used to train artificial intelligence models without prior written authorization from GRIFFINCRAFT S.R.L.</p>
<p>These Guidelines do not prohibit creators from using lawful AI tools in the creation of their own original works.</p>
<hr/>
<h1>15. DOMAIN NAMES AND BRANDING</h1>
<p>You may not register, operate, or promote websites, domains, social media accounts, or other services in a manner likely to cause confusion regarding their affiliation with QuestGuard.</p>
<p>Examples include domain names or branding that falsely imply official status, sponsorship, or ownership by GRIFFINCRAFT S.R.L.</p>
<hr/>
<h1>16. MERCHANDISE</h1>
<p>You may create and sell merchandise based upon your own original creations.</p>
<p>You may not create or sell merchandise using:</p>
<ul>
<li><p>QuestGuard&#39;s logo;</p>
</li>
<li><p>official artwork;</p>
</li>
<li><p>official branding;</p>
</li>
<li><p>official graphic assets;</p>
</li>
<li><p>official publications;</p>
</li>
</ul>
<p>without express written permission.</p>
<hr/>
<h1>17. FEEDBACK AND COMMUNITY CONTRIBUTIONS</h1>
<p>We welcome suggestions, ideas, bug reports, balance proposals, and other feedback.</p>
<p>Submission of feedback does not transfer ownership of QuestGuard to you, nor does it entitle you to compensation if your ideas are implemented.</p>
<hr/>
<h1>18. RESERVATION OF RIGHTS</h1>
<p>Except for the permissions expressly granted by these Guidelines, all rights are reserved.</p>
<p>No permission should be implied beyond what is expressly stated.</p>
<hr/>
<h1>19. REVOCATION</h1>
<p>GRIFFINCRAFT S.R.L. reserves the right to revoke the permissions granted under these Guidelines with respect to any creator or work that:</p>
<ul>
<li><p>violates these Guidelines;</p>
</li>
<li><p>infringes QuestGuard&#39;s intellectual property;</p>
</li>
<li><p>falsely represents an affiliation with QuestGuard;</p>
</li>
<li><p>materially harms the QuestGuard community or brand;</p>
</li>
<li><p>facilitates piracy or circumvention of official Products.</p>
</li>
</ul>
<p>Such revocation may apply to specific works, specific uses, or specific creators, depending on the circumstances.</p>
<hr/>
<h1>20. CHANGES TO THESE GUIDELINES</h1>
<p>QuestGuard is a living platform, and these Guidelines may evolve over time.</p>
<p>Material changes may be communicated through the Service or by other reasonable means where appropriate.</p>
<p>Continued creation or distribution of QuestGuard-compatible content after updated Guidelines take effect constitutes acceptance of the revised Guidelines, where permitted by applicable law.</p>

    </div>)
}